export const DATA_ENTRY_FORM_DEFAULTS = {
  personalData: {
    name: '',
    contact: '',
    email: '',
    dateOfBirth: null,
    gender: '',
    photo: null,
    residentialAddress: '',
    permanentAddress: '',
    nationality: '',
    medicalCondition: '',
  },
  documents: {},
  professionalExperience: [],
  newDoc: {},
};

export const PERSONAL_DATA_STATUS = {
  SHARED: 'shared',
  SUBMITTED: 'submitted',
};

export const DATA_ENTRY_MESSAGES = {
  FETCH_FAILED: 'Failed to fetch candidate details',
  SUBMIT_SUCCESS: 'Candidate data entry submitted successfully',
  SUBMIT_FAILED: 'Failed to submit candidate data entry',
  EXPERIENCE_EDIT_BLOCK: 'Please save or cancel the experience editor before submitting.',
  FORM_NOT_SHARED:
    'Your personal details form has not been shared yet. You’ll receive a link once the onboarding process reaches this step.',
};
